import React from "react";
import WellnessTagIcon from "../Icons/WellnessTagIcon";

interface IWellnessSuccessAvatar{
  image:string;
  name: string;
  showWellnessTag?: boolean;
}

const WellnessSuccessAvatar = ({ image, name, showWellnessTag = true }: IWellnessSuccessAvatar) => {
  return (
    <div className="flex items-center bg-violet-5 p-4 rounded-full">
      <div className="flex items-center p-3.5 rounded-full bg-violet-6">
        <div className="bg-white p-0.5 rounded-full relative">
          {!image ?
            <div
              className="flex items-center justify-center
              rounded-full bg-taupe-1 text-taupe-2 h-16 w-16 text-4xl geograph-regular"
            >
              {name?.charAt(0).toUpperCase()}
            </div>:
            <img className="rounded-full" src={image} height={75} width={75} />}
          {showWellnessTag && <WellnessTagIcon width={30} height={30} transformX="49" transformY="-23" />}
        </div>
      </div>
    </div>
  );
};

export default WellnessSuccessAvatar;
